import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import AdminPlaceholder from 'components/consumer/AdminPlaceholder';
const withAdminPlaceholderHOC = ({
  componentName = ''
}) => WrappedComponent => {
  const WrappedComponentWithAdminPlaceholder = t0 => {
    const $ = _c(6);
    let isAdmin;
    let props;
    if ($[0] !== t0) {
      ({
        isAdmin,
        ...props
      } = t0);
      $[0] = t0;
      $[1] = isAdmin;
      $[2] = props;
    } else {
      isAdmin = $[1];
      props = $[2];
    }
    if (isAdmin) {
      let t1;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = <AdminPlaceholder>{componentName} Placeholder for Variant Builder. <br />The component will display in Consumer</AdminPlaceholder>;
        $[3] = t1;
      } else {
        t1 = $[3];
      }
      return t1;
    }
    let t1;
    if ($[4] !== props) {
      t1 = <WrappedComponent {...props} />;
      $[4] = props;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    return t1;
  };
  WrappedComponentWithAdminPlaceholder.propTypes = {
    isAdmin: PropTypes.bool
  };
  return WrappedComponentWithAdminPlaceholder;
};
export default withAdminPlaceholderHOC;